import type { FaireProductEntity } from "../../entity_types/product";

export const p_zmn4cmhwkg: FaireProductEntity = {
  token: "p_zmn4cmhwkg",
  type: "product",
  name: "Valerian Dream Organic Herbal Tea Sachets",
  brandToken: "b_9jd96k047p",
  brandName: "Rishi Tea & Botanicals",
  imageUrl: "https://cdn.faire.com/fastly/a39735323f3dd0e9a6a8173b37e7717f8b76755813bdf53bc66d7d549704e7e7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b61ffe0732bbdde075ac8eca8dd84efab3acc257e890a3e747ff000eeab99e4b.png",
    "https://cdn.faire.com/fastly/77ffade5f0606d07b50f6f34f7e787c15b322b58cf7f0ea9166614f111c46bd0.jpeg",
    "https://cdn.faire.com/fastly/417a13dc30a49726db39da6aa7ee40043439cae54dd4511ab80eec9e1a67e556.jpeg",
    "https://cdn.faire.com/fastly/c55e19e43373653dc0e68b87b95946f4f43da97727af7ee42ac44279c1a4c15a.jpeg"
  ],
  priceDollars: 10.39,
  description: "This item comes in a case of 6 retail-ready boxes of 15 sachets.\n\nValerian root is a bittersweet botanical with a perfumed, slightly musky aroma. It has a soothing effect and has been used for centuries in Europe as an herbal tea to promote restful sleep. Valerian Dream’s wonderfully floral fragrance highlights complementary nervine tonic herbs like cardamom and fennel to aid in relaxation. Dream away...\n\nTASTING NOTES\nCalming botanical and aromatic flowers with the relaxing effects of valerian root.\n\nCAFFEINE LEVEL\nNone",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:00:22.803Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
